import { Dropdown, Option } from "@fluentui/react-components";
import { OptionOnSelectData, SelectionEvents } from "Shared/FluentUIUnstableDef";
import React, { useCallback, useMemo } from "react";

import { observer } from "mobx-react";
import { timeZoneList } from "Store/TimeStore";
import { useGlobalSetting } from "Store/GlobalSettingStore";
import { useMinuteTick } from "../useMinuteTick";
import { useStyles } from "./AppMenuSetting.styles";
import { useTimeZone } from "Shared/Hooks";

const TimezoneDropDownBase = () => {
    const classNames = useStyles();
    const timeStore = useGlobalSetting("time");
    const currentTime = useMinuteTick();
    const { utcDateTime } = useTimeZone();
    const timenow = utcDateTime(currentTime);

    const selectedTimeZone = useMemo(() => timeZoneList.find((zone) => zone.zone === timeStore.selectedTimeZone)?.display ?? "", [timeStore.selectedTimeZone]);

    const onOptionSelect = useCallback(
        (_event: SelectionEvents, data: OptionOnSelectData) => {
            const selected = data.optionValue;
            const selectedZone = timeZoneList.find((zone) => selected === zone.display);
            timeStore.setSelectedTimeZone(selectedZone?.zone ?? "");
        },
        [timeStore]
    );

    return (
        <>
            <div className={classNames.text}>Time zone</div>
            <div className={classNames.dropdownContainer}>
                <Dropdown
                    className={classNames.dropdown}
                    onOptionSelect={onOptionSelect}
                    value={selectedTimeZone}
                    defaultValue={selectedTimeZone}
                    aria-label="Time zone"
                >
                    {timeZoneList.map((zone) => {
                        const time = timenow
                            .setZone(zone.zone)
                            .toLocaleString({ month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hour12: false });
                        return (
                            <Option key={zone.zone} value={zone.display} text={zone.display} aria-label={zone.display}>
                                <div className={classNames.timezoneLine}>
                                    <span className={classNames.timezoneName}>{zone.display}</span>
                                    <span className={classNames.timezoneClock}>{time}</span>
                                </div>
                            </Option>
                        );
                    })}
                </Dropdown>
            </div>
        </>
    );
};

export const TimezoneDropDown = observer(TimezoneDropDownBase);
